import * as React from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { useStaticContext } from "../../../core";
import { ExternalPaneButton } from "../../../core/containers/Menu/Desktop/components/ExternalPane";
import { E2EIdentifier } from "../../../core/e2e/E2EIdentifier";
import { formatCashAmount } from "../../../core/utils/formatters";
import { APINames } from "../../../legacy/api/api.names";
import { themeColors } from "../../../ui/_themes/constants/colors";
import { IState } from "../../redux";

const GameRulesStyle = styled.div`
  margin-bottom: 2em;
  margin-top: 1em;

  @media (min-width: 640px) {
    /* desktop */
    margin-top: 0;
  }

  main {
    color: ${themeColors.onPrimary};
    text-align: left;
  }

  section {
    color: ${themeColors.onPrimary};
    margin-top: 2em;
    font-weight: bold;
  }

  section > div {
    margin-bottom: 0.5em;
  }

  aside {
    display: flex;
    flex-flow: column;
    align-items: center;
    padding-top: 0.6em;
  }

  h3 {
    text-align: center;
    color: ${themeColors.analogous};
    margin-bottom: 1.2em;
    font-size: 0.88em;
    font-weight: 700;
    letter-spacing: 0.03em;
    margin-top: 0;
  }
`;

export const GameInformation = ({
  language,
  gameInformation,
  currencyFormat
}) => {
  const {
    gameClientVersion,
    gameServerVersion,
    minBet,
    maxBet
  } = gameInformation;
  const { GameClientVersion, GameServerVersion, MinBet, MaxBet } = language;
  return (
    <section>
      {gameClientVersion && (
        <div>
          {GameClientVersion} {gameClientVersion}
        </div>
      )}
      {gameServerVersion && (
        <div>
          {GameServerVersion} {gameServerVersion}
        </div>
      )}
      {minBet && (
        <div>
          {MinBet} {formatCashAmount(minBet, currencyFormat)}
        </div>
      )}
      {maxBet && (
        <div>
          {MaxBet} {formatCashAmount(maxBet, currencyFormat)}
        </div>
      )}
    </section>
  );
};

export const GameRules = () => {
  const { language } = useStaticContext();
  const { menu, gameInformation, money } = useSelector(
    (state: IState) => state
  );
  const { gameRulesContent } = menu;
  const { currencyFormat } = money;

  return (
    <GameRulesStyle>
      {gameRulesContent && (
        <main>
          <div dangerouslySetInnerHTML={{ __html: gameRulesContent }} />
          {gameInformation && (
            <GameInformation
              language={language}
              gameInformation={gameInformation}
              currencyFormat={currencyFormat}
            />
          )}
        </main>
      )}
      {!gameRulesContent && (
        <aside>
          <h3>{language.GameRulesDescription}</h3>
          <ExternalPaneButton
            data-e2e-id={E2EIdentifier.GAME_RULES_BUTTON}
            apiName={APINames.GAME_RULES_BUTTON}
            label={language.GameRulesButton}
          />
        </aside>
      )}
    </GameRulesStyle>
  );
};
